module.exports = __webpack_public_path__ + "img/workbook.1c7278b6.jpg";